<template>
  <div class="print">

    <div class="print-title">안전보건관리담당자   지정서</div>
    <div>
      <div class="division-title">1. 선임자</div>
      <div class="division-body flex">
        <div class="label">· 성　명  : </div>
        <div class="value">{{ form.subInfo['성명']}}</div>
      </div>
      <div class="division-body flex">
        <div class="label">· 직　책  : </div>
        <div class="value">{{ form.subInfo['직책']}}</div>
      </div>
      <div class="division-body flex">
        <div class="label">· 자　격  : </div>
        <div class="value">{{ form.subInfo['자격']}}</div>
      </div>
      <div class="division-body flex">
        <div class="label">· 선임일  : </div>
        <div class="value">{{ form.subInfo['선임일']}}</div>
      </div>
    </div>
    <div class="mt-12">
      <div class="division-title">2. 수행업무</div>
      <div class="division-body">
        <div class="label ml-12">· 「산업안전보건법 시행령」제25조 각 호에 따른 업무</div>
      </div>
    </div>

    <div class="mt-24">
      <div class="division-body">
        <div>
          <div>
            귀하를
            <span class="px-2">{{ form.stdInfo.field_name }}</span>
            <span v-if="form.stdInfo.field_name !== form.stdInfo.department" class="px-2">{{ form.stdInfo.department}}</span>
            「산업안전보건법」제19조 제1항에 따른 안전보건관리담당자로 선임합니다.
          </div>
        </div>
        <div class="my-24 text-center">{{ form.subInfo['선임일']}}</div>
      </div>
    </div>

    <div class="mt-24">
      <div class="division-body text-right">
        <span>대표이사</span>
        <span class="px-4">{{ form.subInfo['대표이사']}}</span>
        <span>(직인)</span>
      </div>
    </div>

    <div class="my-6 w-full dotted-line"/>

    <div>
      <div class="division-body">
        <div>
          <div>
            본인은
            <span class="px-2">{{ form.stdInfo.field_name }}</span>
            안전·보건에 관하여 사업주를 보좌하고 관리감독자에게 조언·지도하는 업무를 수행하는 안전보건관리담당자로 선임된 사실을 확인합니다.
          </div>
        </div>
        <div class="my-28px text-center">{{ form.subInfo['선임일']}}</div>
      </div>
    </div>

    <div class="mt-24">
      <div class="division-body flex" style="align-items: center; justify-content: right;">
        <span>성명</span>
        <span class="px-4">{{ form.subInfo['성명']}}</span>
        <div style="width: 100px;">
          <img v-if="form.subInfo['서명']" :src="form.subInfo['서명']" width="100%" alt="Signature" class="signatureImg" />
          <div v-else class="signatureImg"></div>
        </div>
      </div>
    </div>


  </div>
</template>

<script>
import PrintCheckbox from "@/components/print/PrintCheckbox.vue";

export default {
  name: "Print",
  components: {PrintCheckbox},

  props: {
    isPrint: Boolean,
    board: Object,
    form: Object,
  },

  computed: {
    inspectList () {
      let tempTitle = '';
      for (const inspect of this.form.inspectList) {
        for (const item of inspect.list) {
          if (tempTitle !== item.title) {
            tempTitle = item.title;
          } else {
            item.title = '';
          }
        }
      }
      return this.form.inspectList
    }
  },
}
</script>

<style lang="scss" scoped>
.print {
  .print-title {
    font-size: 48px;
    font-weight: 700;
    color: #3C3C3C;
    text-align: center;
    padding: 20px 0;
    text-decoration: underline;
  }
  .division-title {
    font-size: 28px;
    font-weight: 700;
    color: #3C3C3C;
    padding: 1.25rem 0rem;
  }

  .division-body {
    margin: 10px 0;
    font-size: 28px;
    font-weight: 400;

    .label {
      padding: 0 20px;
      color : #3C3C3C;
    }
  }

  .dotted-line {
    border-top: 1px dashed black;
  }

  /* 테이블 공통 (색상, 테두리 등) */
  table {
    table-layout: fixed;
    border-collapse: collapse;

    th, td {
      border: 1px solid #757575;
      text-align: center;
      font-size: 18px;
    }
    th {
      background-color: #ececec;
      font-weight: 500;
      padding: 1.5rem 0;
    }
    td {
      word-break: keep-all;
      img {
        display: inline-block;
      }
    }
    .th-background {
      background-color: #ececec;
      white-space: nowrap;
    }
    .check-container {
      padding: 10px 14px 0 14px;
      text-align: left;

      div {
        margin-bottom: 8px;
      }
      img {
        display: inline-block;
        margin-right: 8px;
      }
    }
    .text-left {
      text-align: left;
      padding: 10px 14px;
    }
  }

  /* 결재란 */
  .section-approval {
    display: grid;
    grid-template-columns: 1fr auto;

    .table-approval-field {
      th { width: 120px; padding: 10px 14px;}
      th:first-child { width: 38px }
      td { height: 80px; }

      tr:last-child {
        th, td { border-bottom: none }
      }
    }
  }

  /* 기본정보 */
  .section-stdInfo {
    th { width: 140px; }
    td div { border: none; }
  }

  /* 점검대상 */
  .section-inspect {
    td {
      padding: 1rem;
      text-align: left
    }
  }

  .section-file {
    th { width: 234px; }
  }

  .section-photo {
    td { padding: 1rem; }
  }
}


@media print {
  .page-break { page-break-inside:avoid; page-break-after:auto }
  thead { display:table-header-group; }
}
</style>
